export default `
    ... on ds_GlobalCode_GlobalSet {
        id
        name
        globalCode_HeadCode
        globalCode_BodyCode
    }
`